import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const UnitsTableSkeleton: React.FC = () => {
  return (
    <Grid container item direction="column" spacing={2}>
      <Grid item>
        <Skeleton variant="rect" height={56} style={{ borderRadius: 8 }} animation="wave" />
      </Grid>
      <Grid item>
        <Skeleton variant="rect" height={56} style={{ borderRadius: 8 }} animation="wave" />
      </Grid>
      <Grid item>
        <Skeleton variant="rect" height={56} style={{ borderRadius: 8 }} animation="wave" />
      </Grid>
    </Grid>
  );
};

export default UnitsTableSkeleton;
